import React from 'react';

import { ImageProps } from '@wegroup/design-system';

const DisabledModulePagePicture: React.FC<ImageProps> = (props) => {
  return null;
};

export default DisabledModulePagePicture;
